import React, { useEffect, useState, useContext, useMemo } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Loader from '../Home/Loader'
import HeaderMain from '../Home/Headers/HeaderMain'
import Footer from '../Home/Footer';
import Segments from './Segments';
import ErrorAlert from '../Alerts/ErrorAlert';
import { ProductContext } from '../../context/ProductContext';
import BtnShoppingcartFloat from '../../utils/BtnShoppingcartFloat';
import Swal from 'sweetalert2';

import AlertSmall from '../Alerts/AlertSmall';
import useSEO from '../../hooks/useSEO';
import Btnquote from '../../utils/Btnquote';
import { PreOrderFetchAPI } from '../../api/PaymentPost/PreOrder';
import { calculateInvoiceTotals } from '../../utils/CalculateTotals';
import { OrderNumberFetchAPI } from '../../api/PaymentPost/OrderNumber';

import ProductInfoSection from './ProductInfoSection';
import ProductDetail from './ProductDetail';
import Layout from '../../layout/Layout';
import { buildCloudinaryImageUrl } from "../../utils/CloudinaryImageUrl";
import { useTableSession } from "../../context/TableSessionContext";

const Product = () => {
    const navigate = useNavigate();
    const { hasTableSession, addSharedItem } = useTableSession();
    const { productData } = useContext(ProductContext); // <-- Aquí consumes el contexto
    const [shoppingcart, setShoppingcart] = useState(() => {
        if (localStorage.getItem('shoppingCart') != null && localStorage.getItem('shoppingCart') != undefined && localStorage.getItem('shoppingCart') != '') {
            return JSON.parse(localStorage.getItem('shoppingCart'))
        } else {
            return []
        }
    });
    const [quoteLocal, setQuoteLocal] = useState(() => {
        if (localStorage.getItem('quoteData') != null && localStorage.getItem('quoteData') != undefined && localStorage.getItem('quoteData') != '') {
            return JSON.parse(localStorage.getItem('quoteData'))
        } else {
            return null
        }
    })

    //states
    const [quoteData, setQuoteData] = useState(false)
    const [ordersQuote, setOrdersQuote] = useState([])
    const [amount, setAmount] = useState(1)
    // "Comer aqui" / "para llevar" - solo elegible dentro de una sesion de mesa (ver Segments.jsx).
    // Siempre arranca en "comer aqui" por defecto, sin importar que se toque o no el selector.
    const [deliveryType, setDeliveryType] = useState("comer aqui")
    const [priceBase, setPriceBase] = useState(0)
    const [segmentsGroup, setSegmentsGroup] = useState([])
    const [segmentsNow, setSegmentsNow] = useState([])
    const [handlerevent, setHandlerEvent] = useState(0)
    const [handlerEventAction, sethandlerEventAction] = useState(0)
    const [modalViewImg, setModalViewImg] = useState(false)
    const [note, setNote] = useState("")
    const [stateRequest, setStateRequest] = useState(false)
    const [quoteMode, setQuoteMode] = useState(() => {
        if (localStorage.getItem("quoteMode") == "" || localStorage.getItem("quoteMode") == "false" || localStorage.getItem("quoteMode") == null || localStorage.getItem("quoteMode") == undefined) {
            return false
        } else {
            return true
        }
    })

    const [invoiceTip, setInvoiceTip] = useState(0)
    const [totaltopay, settotaltopay] = useState(0)
    const [invoiceTotal, setInvoiceTotal] = useState(0);
    const [invoiceTotalItbms, setInvoiceTotalItbms] = useState(0);
    const [invoiceSubtotal, setInvoiceSubtotal] = useState(0);
    const [invoiceTotalDiscount, setInvoiceTotalDiscount] = useState(0);
    const [invoiceDeliveryFee, setInvoiceDeliveryFee] = useState(0);
    const [invoiceTaxDeliveryFee, setInvoiceTaxDeliveryFee] = useState(0);
    const [taxesArrayAll, setTaxesArrayAll] = useState([]);

    const [clientData, setClientData] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            return JSON.parse(localStorage.getItem('client'))
        } else {
            return null
        }
    })

    const [guestClient, setGuestClient] = useState(() => {
        if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
            return localStorage.getItem('guestClient')
        } else {
            return null
        }
    });

    let business = ""

    let logo = ""
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
        logo = localStorage.getItem('logo')
    }

    if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {

    } else {

        business = JSON.parse(localStorage.getItem("business"));
    }


    //===========================================================================================================
    //add product to shopingcart 
    const addProductSelectToShoppingcart = async (shop, product, temporal_segment_string, quoteCreate) => {

        // A table participant never owns a local cart. The backend creates a
        // DRAFT line atomically and broadcasts the authoritative snapshot.
        if (hasTableSession && !quoteCreate) {
            try {
                await addSharedItem(product);
                setAmount(1);
                if (shop === true) navigate(`/cart`);
                else AlertSmall("Producto agregado al pedido compartido", "success");
            } catch (err) {
                ErrorAlert("No fue posible agregar el producto", "Intenta nuevamente.", "warning");
            }
            return;
        }


        let temporalShopingCart = [];
        let shoppingCart = []
        if (quoteCreate) {
            shoppingCart = []
        } else {
            shoppingCart = localStorage.getItem('shoppingCart');
        }

        if (shoppingCart == null || shoppingCart == undefined || shoppingCart == "") {
            temporalShopingCart = [];
        } else {
            temporalShopingCart = JSON.parse(shoppingCart);
        }

        let turn = 0;
        //check item string segments into shopingcart
        for (let shopping = 0; shopping < temporalShopingCart.length; shopping++) {
            if (product.group_id == temporalShopingCart[shopping].group_id) {
                if (temporalShopingCart[shopping].segments_string === temporal_segment_string) {
                    if (temporalShopingCart[shopping].descuento == 0) {
                        temporalShopingCart[shopping].amount = (temporalShopingCart[shopping].amount + amount);
                        temporalShopingCart[shopping].cantidadItem = temporalShopingCart[shopping].amount;
                        turn = 1;
                    }
                }
            }
        }

        if (turn == 0) {
            //We add the new product to the shopping cart 
            temporalShopingCart.push(product);
            if (!quoteCreate) { localStorage.setItem('shoppingCart', JSON.stringify(temporalShopingCart)); }
        } else {
            if (!quoteCreate) { localStorage.setItem('shoppingCart', JSON.stringify(temporalShopingCart)); }
        }



        // Solo calcular totales si NO es cotización
        if (quoteCreate) {
            let result = calculateInvoiceTotals(temporalShopingCart, [], 0);


            setInvoiceTotalDiscount(result.invoiceTotalDiscount);
            setInvoiceSubtotal(result.invoiceSubtotal);
            setInvoiceTotalItbms(result.invoiceTotalItbms);
            setInvoiceTotal(result.invoiceTotal);
            setInvoiceDeliveryFee(result.invoiceDeliveryFee);
            setInvoiceTaxDeliveryFee(result.invoiceTaxDeliveryFee);
            setTaxesArrayAll(result.taxesArrayAll);
            settotaltopay(result.totaltopay);

            if (quoteLocal !== null) {
                let groups = quoteLocal.groups;
                let newShoppingCart = [...temporalShopingCart, ...groups];

                const resultQuoteLocal = calculateInvoiceTotals(newShoppingCart, [], 0);
                updatePreOrder(quoteLocal, newShoppingCart, resultQuoteLocal.invoiceTotalDiscount, resultQuoteLocal.invoiceSubtotal, resultQuoteLocal.invoiceTotalItbms, resultQuoteLocal.invoiceTotal, resultQuoteLocal.invoiceDeliveryFee, resultQuoteLocal.invoiceTaxDeliveryFee, resultQuoteLocal.taxesArrayAll, resultQuoteLocal.totaltopay);
            } else {

                if (ordersQuote.length > 0) {

                    let filter = ordersQuote.filter(order => order.is_authorized === false)

                    if (filter.length === 0 || filter == undefined) {
                        createPreOrder(temporalShopingCart, result.invoiceTotalDiscount, result.invoiceSubtotal, result.invoiceTotalItbms, result.invoiceTotal, result.invoiceDeliveryFee, result.invoiceTaxDeliveryFee, result.taxesArrayAll, result.totaltopay);
                    } else {
                        let orderQuoteNow = filter[filter.length - 1];
                        let groups = orderQuoteNow.groups;
                        let newShoppingCart = [...temporalShopingCart, ...groups];

                        const resultQuoteNow = calculateInvoiceTotals(newShoppingCart, [], 0);

                        updatePreOrder(orderQuoteNow, newShoppingCart, resultQuoteNow.invoiceTotalDiscount, resultQuoteNow.invoiceSubtotal, resultQuoteNow.invoiceTotalItbms, resultQuoteNow.invoiceTotal, resultQuoteNow.invoiceDeliveryFee, resultQuoteNow.invoiceTaxDeliveryFee, resultQuoteNow.taxesArrayAll, resultQuoteNow.totaltopay);
                    }
                } else {
                    createPreOrder(temporalShopingCart, result.invoiceTotalDiscount, result.invoiceSubtotal, result.invoiceTotalItbms, result.invoiceTotal, result.invoiceDeliveryFee, result.invoiceTaxDeliveryFee, result.taxesArrayAll, result.totaltopay);
                }
            }

        } else {
            setShoppingcart(temporalShopingCart);
        }

        //reset amount in infoProduct
        setAmount(1);
        if (shop == true) {
            navigate(`/cart`);
        } else {
            //AlertSmall("Se agrego exitosamente al carrito", "success");
            //navigate(`/menu`)
        }
    }


    const addpromotionToShoppingCart = (shop, promotion, quoteCreate) => {

        if (quoteCreate) {
            setAmount(1);
            return;
        }

        let temporalShopingCart = [];
        let shoppingCart = localStorage.getItem('shoppingCart');
        if (shoppingCart == null || shoppingCart == undefined || shoppingCart == "") {
            temporalShopingCart = [];
        } else {
            temporalShopingCart = JSON.parse(shoppingCart);
        }

        let turn = 0;
        temporalShopingCart.forEach((product) => {
            if (product.promotion_id) {
                if (product.promotion_id == promotion.promotion_id) {
                    ErrorAlert("Puedes incrementar la cantidad del mismo en el carrito.", "Ya existe esta promocion en el carrito.", "warning");
                    turn = 1;
                }
            }
        });

        if (turn == 0) {
            //We add the new product to the shopping cart 
            temporalShopingCart.push(promotion);
            localStorage.setItem('shoppingCart', JSON.stringify(temporalShopingCart));
        } else {
            localStorage.setItem('shoppingCart', JSON.stringify(temporalShopingCart));
        }

        setShoppingcart(temporalShopingCart);

        //reset amount in infoProduct
        setAmount(1);
        if (shop == true) {
            navigate(`/cart`);
        } else {
            //AlertSmall("Se agrego exitosamente al carrito", "success");
            //navigate(`/menu`)
        }
    }

    // Función para incrementar el contador
    const increment = () => {
        setAmount(amount + 1);
        setHandlerEvent(1)
    };

    // Función para decrementar el contador
    const decrement = () => {
        if (amount <= 1) {
            setAmount(1);
        } else {
            setAmount(amount - 1);
        }
        setHandlerEvent(1)
    };

    // format json of product to add shopppingcart
    const formatJsonToAddShoppingCart = (shop, dataProduct, status, addAuto, segmentsAuto, quoteCreate) => {
        let formatProductAdd = {}
        let idCheckBox = ""
        let detailSegments = []
        if (dataProduct == undefined) {
            // Copia, no la misma referencia: mas abajo se reasigna formatProductAdd.segments (a la forma
            // del carrito, sin .items) - sobre productData eso pisaba el producto guardado en el
            // contexto, y al volver con "atras" desde /cart la pantalla /product se rendereaba con
            // segments sin items y explotaba en blanco (Segments.jsx: reading 'map').
            formatProductAdd = { ...productData }
            idCheckBox = "listGroupRadioGrid"
            detailSegments = segmentsGroup
        } else {
            formatProductAdd = dataProduct
            idCheckBox = "listGroupRadioGrid"

            if (addAuto == true) {
                detailSegments = segmentsAuto


            } else {
                detailSegments = segmentsNow

            }

        }

        if (formatProductAdd.img == null || formatProductAdd.img == "" || formatProductAdd.img == undefined) {
            formatProductAdd.img = logo
        }
        //For default we set that the amount of the selected product depending the number 

        formatProductAdd.segments_originally = detailSegments
        formatProductAdd.amount = amount;
        formatProductAdd.cantidadItem = amount;
        formatProductAdd.delivery_type = deliveryType;
        formatProductAdd.note = '';
        formatProductAdd.unit_discount = 0;
        formatProductAdd.product_discount = 0;
        formatProductAdd.base_price = formatProductAdd.price;
        formatProductAdd.valueOriginal = formatProductAdd.price;
        formatProductAdd.descuento = formatProductAdd.product_discount;
        formatProductAdd.discount = formatProductAdd.product_discount;
        //For default we initialice the segments empty of the selected product 
        formatProductAdd.segments = [];
        formatProductAdd.DetalleSegmentos = [];
        formatProductAdd.segments_string = ""
        formatProductAdd.note = note;

        //find segments checked
        let temporal_segment_string = ""
        detailSegments.forEach((segment) => {

            if (addAuto == true) {
                if (segment.segment_item_id_default == null) {
                    let dataFirsItem = segment.items[0]
                    addItem(dataFirsItem)
                } else {
                    segmentsItems()
                }
            } else {
                segmentsItems()
            }

            //Scooch items of segment
            function segmentsItems() {
                segment.items.forEach((item) => {

                    if (addAuto == true) {//if addAuto is true add automatic item defauld in group
                        if (item.item_id == segment.segment_item_id_default) {
                            addItem(item)


                        }

                    } else {
                        let idCheckedItem = document.getElementById(idCheckBox + segment.segment_id + item.item_id)
                        if (idCheckedItem.checked == true) {
                            addItem(item)
                        }
                    }
                })
            }

            //Add item selected
            function addItem(itemNow) {
                itemNow.amount = amount
                temporal_segment_string = formatProductAdd.segments_string + "" + segment.segment_id + "" + itemNow.item_id
                formatProductAdd.segments_string = formatProductAdd.segments_string + "" + segment.segment_id + "" + itemNow.item_id
                // El spread de ...itemNow trae su propio "name" (el del ITEM elegido, ej. "Pollo") - sin
                // sobreescribirlo despues, ese es el que queda guardado como segment.name en vez del
                // nombre del segmento/grupo (ej. "Ingrediente Porcion Chica arroz"), que es lo que la
                // comanda de cocina y el POS esperan mostrar como etiqueta (ver
                // controller/orders.js#getFilterTempOrderByIdToImpress en el backend: "segment.name : item.name").
                formatProductAdd.segments.push({ ...itemNow, name: segment.name, segment_name: segment.name, cantidadItem: amount, item: itemNow })
                formatProductAdd.DetalleSegmentos.push({ ...itemNow, name: segment.name, segment_name: segment.name, cantidadItem: amount, item: itemNow })
                formatProductAdd.price = formatProductAdd.price + itemNow.price
            }
        });

        if (status == true) {
            //saveDataGroupByCombo(formatProductAdd)
        } else {
            if (formatProductAdd.promotion_id) {
                addpromotionToShoppingCart(shop, formatProductAdd, quoteCreate)
            } else {
                addProductSelectToShoppingcart(shop, formatProductAdd, temporal_segment_string, quoteCreate)
            }

            //clearDataInfoProduct()
        }
    }

    {/*===========================================================================================
    ============================================= FUNCTIONS INVOICE TOTALS ===================================================
    ========================================================================================================================*/}
    // get order number in process
    const getOrderNumber = async () => {
        let token = undefined;
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))

        try {
            const response = await OrderNumberFetchAPI.getOrderNumber(branchoffice.id, token)
            return (response.data.next_transaction_code);
        } catch (err) {

        }

    }

    //create preOrder
    const createPreOrder = async (temporalShopingCart, invoiceTotalDiscount, invoiceSubtotal, invoiceTotalItbms, invoiceTotal, invoiceDeliveryFee, invoiceTaxDeliveryFee, taxesArrayAll, totaltopay) => {
        if (stateRequest == false) {



            const transaction_code = await getOrderNumber();

            setStateRequest(true)
            if (temporalShopingCart.length > 0) {
                //LoadingAlert()
                let token = undefined;
                let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
                let machine = JSON.parse(localStorage.getItem('machine'))
                let json = {
                    "transaction_code": transaction_code,
                    "client_name": clientData !== null ? clientData.name : "Cliente generico",
                    "localizador": "00",
                    "client_phone": "0",
                    "ruc": "0000",
                    "dv": "00",
                    "client_id": clientData !== null ? clientData.id : 0,
                    "dgi_qr": "0",
                    "Orden": temporalShopingCart,
                    "combos": [],
                    "Descuento": invoiceTotalDiscount,
                    "Total": invoiceTotal,
                    "itbms": invoiceTotalItbms,
                    "taxes": taxesArrayAll,
                    "subtotal": invoiceSubtotal,
                    "machine_id": machine.id,
                    "branchoffice_id": branchoffice.id,
                    "tipoOrden": "para llevar",
                    "paymethod": 0,
                    "is_discount_notification": false,
                    "is_authorized": false,
                    "is_cupon": false,
                    "is_devolution_notification": false,
                    "is_pre_order": false,
                    "is_quote_order": true,
                    "user": {
                        id: 0,
                        name: "",
                        code: 0
                    },
                    "notes": "AAAAAAAAAAH"
                }

                if (clientData !== undefined && clientData !== null) {
                    json.client_id = clientData.id
                    json.id_Client = 0;
                    json.ruc = clientData.ruc !== "" && clientData.ruc !== "null" && clientData.ruc !== null && clientData.ruc !== undefined ? clientData.ruc : 0
                    json.dv = clientData.dv !== "" && clientData.dv !== "null" && clientData.dv !== null && clientData.dv !== undefined ? clientData.dv : 0
                    json.client_name = clientData.name !== "" && clientData.name !== "null" && clientData.name !== null && clientData.name !== undefined ? clientData.name : "Cliente generico"
                    json.client_phone = clientData.phone !== "" && clientData.phone !== "null" && clientData.phone !== null && clientData.phone !== undefined ? clientData.phone : "0"
                }
                try {
                    const response = await PreOrderFetchAPI.createPreOrder(json, token)
                    setStateRequest(false)
                    AlertSmall("Cotizacion creada con exito.", "success")
                    if (guestClient !== 0 && guestClient !== "0") {
                        localStorage.setItem('quoteData', JSON.stringify(response.data.newTempOrder))
                    }

                    //getTemporalOrderByCode(response.data.newTempOrder.code);
                    navigate(`/order/quote/${response.data.newTempOrder.code}`)
                } catch (err) {
                    setStateRequest(false)
                    ErrorAlert("Error al crear la cotizacion.", "error")

                }
            } else {
                ErrorAlert("Debes agregar  algo al carrito", "No hay productos en el carrito", "info")
            }
        }
    }

    // update pre order
    const updatePreOrder = async (order, temporalShopingCart, invoiceTotalDiscount, invoiceSubtotal, invoiceTotalItbms, invoiceTotal, invoiceDeliveryFee, invoiceTaxDeliveryFee, taxesArrayAll, totaltopay) => {
        if (stateRequest == false) {
            setStateRequest(true)
            let token = undefined;
            let json = {
                "client_name": "",
                "localizador": "00",
                "ruc": 0,
                "dv": 0,
                "is_discount_notification": false,
                "_id": order._id,
                "order_type": order.order_type,
                "groups": temporalShopingCart,
                "combos": [],
                "discounts": order.discounts,
                "taxes": taxesArrayAll,
                "discount": invoiceTotalDiscount,
                "is_authorized": false,
                "total": invoiceTotal,
                "tax": invoiceTotalItbms,
                "subtotal": invoiceSubtotal,
            }

            if (clientData !== undefined && clientData !== null) {
                json.client_id = clientData.id
                json.id_Client = clientData.id;
                json.ruc = clientData.ruc !== "" && clientData.ruc !== "null" && clientData.ruc !== null && clientData.ruc !== undefined ? clientData.ruc : 0
                json.dv = clientData.dv !== "" && clientData.dv !== "null" && clientData.dv !== null && clientData.dv !== undefined ? clientData.dv : 0
                json.client_name = clientData.name !== "" && clientData.name !== "null" && clientData.name !== null && clientData.name !== undefined ? clientData.name : "Cliente generico"
            }

            try {

                const response = await PreOrderFetchAPI.updateOrderTempPreOrder(json, token)

                if (guestClient === 0 || guestClient === "0") {
                    localStorage.removeItem('quoteData')
                }
                setStateRequest(false)
                navigate(`/order/quote/${response.data.code}`)

            } catch (err) {
                setStateRequest(false)
                AlertSmall("No se pudo actualizar la cotizacion", "error")
            }
        }


    }


    //Render
    useEffect(() => {
        // Simulate loading data  
        // Simulate loading data    


        if (productData) {
            setPriceBase(productData.price);

            if (productData.segments) {
                setSegmentsGroup(productData.segments)
            } else {
                setSegmentsGroup([])
            }
        } else {
            //ErrorAlert('', 'Debes selecionar un restaurante.', 'info', 8000)
            navigate(`/Home`);
        }

    }, []);

    useEffect(() => {
        setHandlerEvent(0)
    }, [handlerevent])

    useEffect(() => {
        sethandlerEventAction(0)
    }, [handlerEventAction])


    //SEO Inicial
    // useSEO({
    //     title: "Producto",
    //     bussines_name: business.name,
    //     description: productData.description,
    // });

    const [loading, setLoading] = useState(true);

    // ===================== STATE =====================
    const [activeImg, setActiveImg] = useState(0);
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    const safeImages = useMemo(() => {
        const arr = Array.isArray(productData.images) && productData.images.length ? productData.images : [""];
        return arr;
    }, [productData.images]);


    const formatMoney = (n, currency = "USD") => {
        try {
            return new Intl.NumberFormat("es-PA", { style: "currency", currency }).format(n);
        } catch {
            return `$${Number(n || 0).toFixed(2)}`;
        }
    };
    useEffect(() => {
        setActiveImg((p) => clamp(p, 0, safeImages.length - 1));
    }, [safeImages.length]);


    console.log("Ver producto: ", productData)

    return (
        <>
            {loading && <Loader onFinish={() => setLoading(false)} />}
            {!loading && productData &&
                (<>


                    <Layout shoppingcart={shoppingcart} quoteData={quoteData}  >
                        {/* <HeaderMain shoppingcart={shoppingcart} quoteData={quoteData} /> */}
                        {/* ===================== DETALLE DE PRODUCTO (diseño pdx-) ===================== */}
                        <div className="pdx-page">

                            {/* ── VOLVER: enlace discreto (dos columnas) ── */}
                            <button type="button" className="pdx-back" onClick={() => navigate(`/menu`)}>
                                <i className="uil uil-arrow-left" aria-hidden="true" />
                                Volver al menú
                            </button>

                            <section className="pdx-layout">
                                {/* ===================== GALERÍA ===================== */}
                                <div className="pdx-gallery">
                                    <div className="pdx-main">
                                        {/* ── VOLVER: pastilla sobre la imagen (una columna) ── */}
                                        <button type="button" className="pdx-back-float" onClick={() => navigate(`/menu`)}>
                                            <i className="uil uil-arrow-left" aria-hidden="true" />
                                            <span className="pdx-back-float__long">Volver al menú</span>
                                            <span className="pdx-back-float__short">Menú</span>
                                        </button>

                                        <img
                                            alt={`Producto ${activeImg + 1}`}
                                            src={buildCloudinaryImageUrl({ url: safeImages[activeImg], width: 800, quality: "auto", type: "image" })}
                                            onError={e => e.target.style.opacity = 0} />
                                    </div>

                                    {safeImages.length > 1 && (
                                        <div className="pdx-thumbs" role="tablist" aria-label="Miniaturas del producto">
                                            {safeImages.map((src, i) => (
                                                <button
                                                    key={`${src}-${i}`}
                                                    type="button"
                                                    className={`pdx-thumb ${i === activeImg ? "is-active" : ""}`}
                                                    onClick={() => setActiveImg(i)}
                                                    role="tab"
                                                    aria-selected={i === activeImg}
                                                    title={`Ver imagen ${i + 1}`}
                                                >
                                                    <img alt={`Thumb ${i + 1}`}
                                                        src={buildCloudinaryImageUrl({ url: src, width: 300, quality: "auto", type: "image" })}
                                                        onError={e => e.target.style.opacity = 0}
                                                    />
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* ===================== INFORMACIÓN ===================== */}
                                <div className="pdx-info">
                                    <h1 className="pdx-title">{productData.name}</h1>

                                    <div className="pdx-price">
                                        <span className="pdx-price__value">{formatMoney(priceBase.toFixed(2))}</span>
                                        <span className="pdx-price__label">Precio base</span>
                                    </div>

                                    {productData.description && <p className="pdx-desc">{productData.description}</p>}

                                    {/* Modalidad, cantidad y botón: los pinta Segments */}
                                    <div className="pdx-groups">
                                        {segmentsGroup &&
                                            <Segments segmentsGroup={segmentsGroup} increment={increment} decrement={decrement} amount={amount} formatJsonToAddShoppingCart={formatJsonToAddShoppingCart} selectedGroup={productData} business_name={business.name} note={note} setNote={setNote} priceBase={priceBase} quoteData={quoteData} setQuoteData={setQuoteData} quoteMode={quoteMode} hasTableSession={hasTableSession} deliveryType={deliveryType} setDeliveryType={setDeliveryType} />}
                                    </div>
                                </div>
                            </section>
                        </div>

                        {quoteMode == true && (<Btnquote ordersQuote={ordersQuote} setOrdersQuote={setOrdersQuote} />)}
                        <Footer />

                        {/* NewComponent */}
                        {/* <ProductDetail /> */}


                    </Layout>




                </>)
            }

        </>
    )
}

export default Product